import React from "react";
import { useParams } from "react-router";
import CreateJobContainer from "../../containers/jobs/CreateJob";

const CreateJobPage = () => {
  const { id } = useParams();
  return id ? <CreateJobContainer jobId={id} /> : <CreateJobContainer />;
};

export default CreateJobPage;
